// BottomBar.js
import React from 'react';
import { Box, IconButton, Container } from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter'; // Using Twitter icon for X
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import ChatIcon from '@mui/icons-material/Chat'; // Placeholder for Slack
import EmailIcon from '@mui/icons-material/Email';

const BottomBar = () => {
  const socialLinks = [
    {
      name: 'Email',
      icon: <EmailIcon />,
      url: 'contact@syndatasys.com',
    }
  ];

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        py: 1,
        zIndex: 1100, // Ensure it's above other content
        backgroundColor: 'primary.main',
        color: 'white'
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          {socialLinks.map((link) => (
            <IconButton
              key={link.name}
              component="a"
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.name}
              sx={{ color: 'white' }}
            >
              {link.icon}
            </IconButton>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default BottomBar;